// target blank
var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
} 

// target menu
document.addEventListener("DOMContentLoaded", function () {
  const links = document.querySelectorAll(".wbsimplemenuxs a");

  links.forEach(link => {
    if (link.textContent.trim().includes("Händleranfrage")) {
      link.classList.add("highlight-link");
}});});(()=>{const media=window.matchMedia("(max-width: 749px)");const sync=()=>{document.querySelectorAll(".abz-frequently-bought .cbb-frequently-bought-selector-list").forEach(list=>{Array.from(list.children).slice(2).forEach(item=>{const input=item.querySelector("input[type=checkbox]");if(media.matches&&input&&input.checked){input.click()}item.toggleAttribute("hidden",media.matches)})})};const start=()=>{sync();new MutationObserver(sync).observe(document.body,{childList:true,subtree:true});media.addEventListener("change",sync)};if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",start,{once:true})}else{start()}})();
